import type { HelpFile } from '../../types/help'
import { ReportDefinitionEditTestIds } from '../../../testids/ReportDefinitionEditTestIds'

export const reportDefinitionEditHelp: HelpFile = {
  docPage: '/docs/reporting/definitions',
  texts: {
    [ReportDefinitionEditTestIds.reportDefinitionEditPage]:
      'Edit a report definition — name, description, and the query that drives the report.',
    [ReportDefinitionEditTestIds.inputReportName]:
      'Display name shown to consumers in the catalogue.',
    [ReportDefinitionEditTestIds.inputReportDescription]:
      'Purpose, audience, and key columns of the report.',
    [ReportDefinitionEditTestIds.btnSaveReport]: null,
    [ReportDefinitionEditTestIds.hintSaveLink]:
      'After saving — open the report or continue editing.',
  },
}
